import { adPartnersTo } from '@mc/track-event'

export const getPageLoadIntegrations = (value: boolean = true) => ({
  ...adPartnersTo(value),
  Hotjar: false,
})
